import { AssetInfo } from './../../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-upload-logo-for-business',
  templateUrl: './upload-logo-for-business.component.html',
  styleUrls: ['./upload-logo-for-business.component.scss']
})
export class UploadLogoForBusinessComponent implements OnInit, OnDestroy {
  public buisnessPromotionData: BuisnessPromotion = new BuisnessPromotion();
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService,
    private activemodal: MatDialogRef<UploadLogoForBusinessComponent>
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {
      JSON.parse(data.assetInfo).map((v: any, i: any) => {
        console.log(v.imgUrl.split('/'));
        this.assetList.push({
          assetName: v.imgUrl
            .split('/')
            .pop()
            .substring(v.imgUrl.split('/').pop().lastIndexOf('_') + 1),
          url: v.imgUrl,
          thumbnail: v.imageThumbUrl,
        });
      });
      this.buisnessPromotionData = data;
      this.editMode = true;
    }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this.assetList = []
        this._ngZone.run(() => {
          this.assetList.push({
           assetName: this.fileName,
          "entity_hash": this.parentData.data.hashId,
          "media_url": res.result?.url,
          "thumb_media_url": res.result?.thumbnail,
          "asset_usage_type": "3",
          "is_logo": "1",
          "asset_type": this.assetType
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.buisnessPromotionData.imgUrl = res.result?.url;
      }
   
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPLOAD_ENTITY_MEDIA) {
        if (data) { 
          this.loaderservice.showLoader = false
          this.activemodal.close({msg: 'success'})
        }
       
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    
    
    this.loaderservice.showLoader = true
      setTimeout(() => {
        this._apiService.uploadEntityMedia(this.assetList[0])
      }, 3000);
      
    
    
  }
  assetType: number = 0
  onUploadImage(event: any) {
    this.assetType = 0
    console.log(event);
    console.log(event.target);
    
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    const originalFile = event.target.files[0];
    let fileName = originalFile.name;

    if (fileName.includes(' ')) {
      fileName = fileName.replace(/\s+/g, '_');
    }

    const sanitizedFile = new File([originalFile], fileName, { type: originalFile.type });

    console.log('filename',this.fileName);
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
    const mimeType = event.target.files[0].type;
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', sanitizedFile);
    
    if (mimeType.startsWith('image/')) {
      console.log('image');
      if (sizeinKb > 1021) {
        this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this.assetType = 1
      this._apiService.uploadAssets(formData, 1);
      return;
    }
    if (mimeType.startsWith('video/')) {
      console.log('Video');
      this.assetType = 2
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    this.loader = false;
    this._snackBar.open('File format not supported', 'Ok');
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.buisnessPromotionData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.buisnessPromotionData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.buisnessPromotionData.targetCountry = data.long_name;
      }
    });
  }
}

